/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Grid, Box, Typography, Avatar, Divider } from '@mui/material';
import './OvertimeARModal.css';
import CustomModal from '../../CustomModal/CustomModal';
import ModalHeader from '../../CustomModal/ModalHeader';
import CustomTextField from '../../../components/CustomTextField/CustomTextField';
import CompDirection from '../../../themes/CompDirection';
import { themes } from '../../../themes/themes';
import TakeActionSplitBtn from '../../../components/TakeActionSplitBtn/TakeActionSplitBtn';
import { DataGrid } from '@mui/x-data-grid';
import { getAmount } from '../../../configs/utils';
import { useAppSelector } from '../../../../infra/hooks';
import _ from 'lodash';
import { DateField } from '../../../../components';
import { baseDateFormatting } from '../../../helper';

interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  trans?: any;
  fullData?: any;
  historyData?: any;
  userId?: any;
  handleSubmitAR_Request?: any;
  allActions?: any;
}

const OvertimeARModalPresenter = ({
  isModalOpen,
  closeModal,
  fullData,
  handleSubmitAR_Request,
  userId,
  allActions,
  trans,
}: ModalProps) => {
  const handleTakeAction = (x: any) => {
    if (x) {
      const payload = {
        event: 'overtime',
        instanceId: fullData?.id,
        userId: userId,
        action: x ? x : '',
        context: {},
        model: 'emp_overtimes',
      };
      handleSubmitAR_Request(payload);
    } else {
      return;
    }
  };

  const tableColumns: any = [
    {
      field: 'date',
      headerName: trans('Date'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: (params: any) => (
        <DateField
          value={params?.row?.date}
          format={baseDateFormatting}
        />
      ),
    },
    {
      field: 'hours',
      headerName: trans('Hours'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'amount',
      headerName: trans('Amount'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
  ];

  const storedARData = useAppSelector(
    (state) => state.actionRequiredSlice.actionRequiredData,
  );
  const row_data = _.map(storedARData, (data: any) => {
    return {
      id: data?.id,
      date: data?.date,
      hours: data?.hours,
      amount: getAmount(data?.amount),
    };
  });

  return (
    <CustomModal isModalOpen={isModalOpen} modalHeight="98vh" modalWidth="60vw">
      <ModalHeader
        modal={{ modal_title: trans('Overtime Action Required') }}
        closeModal={closeModal}
      />
      <CompDirection>
        <Grid
          container
          spacing={2}
          style={{
            marginTop: '5px',
          }}
        >
          <Grid item xs={4}>
            <Box className="bg_border_ar_overtime">
              {/* {Employee Intro Box} */}
              <Box
                style={{
                  padding: '1em',
                  border: '1px solid #0000001f',
                  borderRadius: '10px',
                }}
              >
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyContent: 'space-between',
                  }}
                >
                  <Box>
                    <Typography
                      style={{
                        fontFamily: 'Lato',
                        fontSize: '0.7em',
                        color: themes.greyDefault_500,
                        border: '1px solid #9E9E9E',
                        borderRadius: '4px',
                        padding: '4px',
                        alignSelf: 'center',
                      }}
                    >
                      {' '}
                      {fullData?.staff_id}
                    </Typography>
                  </Box>
                  <Box
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <Avatar style={{ height: '3em', width: '3em' }} />
                    <Typography
                      style={{
                        fontFamily: 'Lato',
                        fontSize: '1em',
                        fontWeight: 'bold',
                        color: themes.darkBlue,
                      }}
                    >
                      {fullData?.first_name + ' ' + fullData?.last_name}
                    </Typography>
                    <Typography
                      style={{
                        fontFamily: 'Lato',
                        fontSize: '0.7em',
                        color: themes.greyModalTitle,
                      }}
                    >
                      {fullData?.designation_name}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography>
                      <i
                        className="las la-ellipsis-h"
                        color={themes.greyDefault_500}
                        style={{ height: '1em', width: '1em' }}
                      />
                    </Typography>
                  </Box>
                </Box>
                <Box
                  style={{
                    display: 'flex',
                    padding: '1em',
                    marginTop: '0.5em',
                    width: 'auto',
                    backgroundColor: '#F5F5FA66',
                    height: 'auto',
                    borderRadius: '10px',
                    flexDirection: 'column',
                  }}
                >
                  <Box
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      marginTop: '0.5em',
                    }}
                  >
                    <Typography
                      style={{
                        fontFamily: 'Lato',
                        fontSize: '0.7em',
                        color: themes.greyModalTitle,
                      }}
                    >
                      Department
                    </Typography>
                    <Typography
                      style={{
                        fontFamily: 'Lato',
                        fontSize: '0.7em',
                        color: themes.greyModalTitle,
                      }}
                    >
                      Date Hired
                    </Typography>
                  </Box>
                  <Box
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      marginTop: '5px',
                    }}
                  >
                    <Typography
                      style={{
                        fontFamily: 'Lato',
                        fontSize: '0.7em',
                        fontWeight: 'bold',
                        color: themes.darkBlue,
                      }}
                    >
                      {fullData?.department_name}
                    </Typography>
                    <Typography
                      style={{
                        fontFamily: 'Lato',
                        fontSize: '0.7em',
                        fontWeight: 'bold',
                        color: themes.darkBlue,
                      }}
                    >
                      <DateField
                        value={fullData?.hire_date}
                        format={baseDateFormatting}
                      />
                    </Typography>
                  </Box>
                  <Divider style={{ marginTop: '0.5em' }} />
                  <Box
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      marginTop: '0.5em',
                    }}
                  >
                    <Box>
                      <Typography
                        style={{
                          fontFamily: 'Lato',
                          fontSize: '0.7em',
                          color: themes.greyModalTitle,
                        }}
                      >
                        <i className="las la-envelope-open" /> {fullData?.email}
                      </Typography>
                      <Typography
                        style={{
                          fontFamily: 'Lato',
                          fontSize: '0.7em',
                          color: themes.greyModalTitle,
                        }}
                      >
                        <i className="las la-phone-volume" />
                        {fullData?.phone}
                      </Typography>
                    </Box>
                    <Box>
                      <Typography
                        style={{
                          fontFamily: 'Lato',
                          fontSize: '0.7em',
                          color: '#21D8A5',
                          backgroundColor: '#E8FBF6',
                          padding: '5px',
                          alignSelf: 'center',
                          borderRadius: '4px',
                        }}
                      >
                        {fullData?.status == 1 ? 'Active' : 'In-Active'}
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                <Box
                  style={{
                    borderRadius: '10px',
                  }}
                >
                  <Box
                    style={{
                      display: 'flex',
                      padding: '1em',
                      marginTop: '0.5em',
                      width: 'auto',
                      backgroundColor: '#F5F5FA66',
                      height: 'auto',
                      borderRadius: '10px',
                      flexDirection: 'column',
                    }}
                  >
                    <Box
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}
                    >
                      <Typography
                        style={{
                          fontFamily: 'Lato',
                          fontSize: '0.825em',
                          fontWeight: 'bold',
                          color: themes.darkBlue,
                        }}
                      >
                        Total Overtime
                      </Typography>
                    </Box>
                    <Box
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}
                    >
                      <Typography
                        style={{
                          fontFamily: 'Lato',
                          fontSize: '0.7em',
                          fontWeight: 'bold',
                          color: themes.darkBlue,
                        }}
                      >
                        Effective Date:
                        <DateField
                          value={fullData?.date}
                          format={baseDateFormatting}
                        />
                      </Typography>
                    </Box>
                    <Divider style={{ marginTop: '0.5em' }} />
                    <Box
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        marginTop: '0.5em',
                      }}
                    >
                      <Box>
                        <Typography
                          style={{
                            fontFamily: 'Lato',
                            fontSize: '0.7em',
                            color: themes.greyModalTitle,
                          }}
                        >
                          Total Hours
                        </Typography>
                        <Typography
                          style={{
                            fontFamily: 'Lato',
                            fontSize: '0.7em',
                            color: themes.greyModalTitle,
                          }}
                        >
                          Total Amount
                        </Typography>
                      </Box>
                      <Box>
                        <Typography
                          style={{
                            fontFamily: 'Lato',
                            fontSize: '0.7em',
                            color: themes.greySubtitle,
                          }}
                        >
                          {fullData?.hours}
                        </Typography>
                        <Typography
                          style={{
                            fontFamily: 'Lato',
                            fontSize: '0.7em',
                            color: themes.greySubtitle,
                          }}
                        >
                          {getAmount(fullData?.amount)}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>

              <Box style={{ marginTop: '1em' }}>
                <CustomTextField
                  type="string"
                  label="Comment"
                  placeholder="Write Comment"
                />
              </Box>
              <Box style={{ marginTop: '1.5em', zIndex: '999', width: '100%' }}>
                <TakeActionSplitBtn
                  onAction={(x: any) => handleTakeAction(x)}
                  menu={allActions}
                  title={'Take Action'}
                />
              </Box>
            </Box>
          </Grid>
          {/* {Second Column} */}
          <Grid item xs={8}>
            <Box className="bg_border_ar_overtime2">
              <Typography
                style={{
                  fontFamily: 'Lato',
                  fontSize: '1.25em',
                  fontWeight: 'bold',
                  color: themes.darkBlue,
                }}
              >
                Overtime Details
              </Typography>
              <Box
                className="ar_table_in_overtime_modal"
                sx={{
                  '& .header': {
                    backgroundColor: '#F5F5F5',
                  },

                  width: '100%',
                  marginTop: '2em',
                }}
              >
                <DataGrid
                  sx={{
                    color: '#081735',
                    font: 'normal normal normal 14px/24px Lato;',
                  }}
                  autoHeight
                  disableExtendRowFullWidth
                  disableSelectionOnClick
                  rows={row_data}
                  columns={tableColumns}
                  componentsProps={{
                    pagination: {
                      labelRowsPerPage: trans('Rows per page'),
                    },
                  }}
                />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </CompDirection>
    </CustomModal>
  );
};

export default OvertimeARModalPresenter;
